module.exports = __webpack_public_path__ + "img/sharp-example11.2dd24855.jpg";